function productItemSetup() {
  let allSizes = ["ONE SIZE", "XS", "S", "M", "L"];

  function initializeProductTile(element) {
    if (element) {
      let productTile = element;

      initializeCarousels(productTile);
      initializeQuickAdd(productTile);
    }
  }

  // Library of functions, they get their elements as arguments
  function checkOverflow(element) {
    let carousels = element ? [element] : $(".carousel");

    for (let i in carousels) {
      let carousel = carousels[i],
        leftArrow = $(carousel).parent().find(".slideshow__arrow")[0],
        rightArrow = $(carousel).parent().find(".slideshow__arrow")[1];
      if (carousel && leftArrow && rightArrow) {
        let max = carousel.scrollWidth;
        let w = $(carousel).innerWidth();
        let current = $(carousel).scrollLeft();
        let atEnd = w + current >= max;
        let nextIsHidden = $(rightArrow).css("visibility") === "hidden";
        let previousIsHidden = $(leftArrow).css("visibility") === "hidden";

        if (atEnd && !nextIsHidden) {
          $(rightArrow).css("visibility", "hidden");
        }
        if (current == 0 && atEnd) {
          $(rightArrow).css("visibility", "hidden");

          $(leftArrow).css("visibility", "hidden");
        }

        if (current == 0 && !previousIsHidden) {
          $(leftArrow).css("visibility", "hidden");
        }
        if (current == 0 && !atEnd) {
          $(rightArrow).css("visibility", "visible");
        }
        if (current > 0 && !atEnd) {
          if (nextIsHidden) {
            $(rightArrow).css("visibility", "visible");
          }
          if (previousIsHidden) {
            $(leftArrow).css("visibility", "visible");
          }
        }
      }
    }
  }
  function connectArrows(carousel, leftArrow, rightArrow) {
    if (carousel) {
      $(leftArrow).click((e) => {
        e.preventDefault();
        scrollCarouselLeft(carousel);
      });
      $(rightArrow).click((e) => {
        e.preventDefault();

        scrollCarouselRight(carousel);
      });

      carousel.onscroll = () => {
        checkOverflow(carousel);
      };
    }
  }

  function initializeCarouselArrows(productTile) {
    let carousel = $(productTile).find(".carousel")[0],
      arrows = $(productTile).find(".slideshow__arrow"),
      leftArrow = $(arrows[0])[0],
      rightArrow = $(arrows[1])[0],
      saleCarousel = $(productTile).find(".sale-carousel")[0];
    connectArrows(carousel, leftArrow, rightArrow);
    if (saleCarousel && arrows.length > 3) {
      connectArrows(saleCarousel, $(arrows[2])[0], $(arrows[3])[0]);
    }
  }
  function initializeSwatches(productTile) {
    let swatches = Array.from($(productTile).find(".swatch"));
    swatches.map((el, index) => {
      $(el).click(() => {
        switchVariant(productTile, { ...el.dataset });
      });
    });
  }
  function initializeQuickAdd(productTile) {
    let allProducts = boostPFSAppConfig.products;

    let productId = productTile.dataset.id,
      newProduct = {};

    for (let i in allProducts) {
      if (allProducts[i].id == productId) {
        newProduct = allProducts[i];

        break;
      }
    }
    // build the HTML for the quick add
    var oldSizeWrapper = $(productTile).find(".ProductSizes__Wrapper");
    // inject the html
    var sizeWrapperParent = $(oldSizeWrapper).parent();
    var sizeWrapper = document.createElement("div");
    sizeWrapper.className = "ProductSizes__Wrapper";
    sizeWrapper.id = `product-${newProduct.id}-sizes`;
    let header = document.createElement("h1");
    header.className = "quick-add-header";
    header.textContent = "Add to Bag";
    sizeWrapper.appendChild(header);
    let product_variants = newProduct.variants;
    for (let variant in product_variants) {
      if (allSizes.includes(product_variants[variant].title)) {
        if (product_variants[variant].available) {
          let form = document.createElement("form");
          form.method = "post";
          form.action = "/cart/add";
          form.enctype = "multipart/form-data";
          form.id = `product_form_${newProduct.id}`;
          form.className = "shopify-product-form";
          let hiddenInputFormType = document.createElement("input");
          hiddenInputFormType.type = "hidden";
          hiddenInputFormType.name = "form_type";
          hiddenInputFormType.value = "product";
          form.appendChild(hiddenInputFormType);
          let hiddenInputFormat = document.createElement("input");
          hiddenInputFormat.type = "hidden";
          hiddenInputFormat.name = "utf8";
          hiddenInputFormat.value = "✓";
          form.appendChild(hiddenInputFormat);
          let hiddenInputID = document.createElement("input");
          hiddenInputID.type = "hidden";
          hiddenInputID.name = "id";
          hiddenInputID.value = product_variants[variant].id;
          form.appendChild(hiddenInputID);
          let inputSubmit = document.createElement("input");
          inputSubmit.type = "submit";
          inputSubmit.className = "quick_size_button";
          inputSubmit.name = "button";
          inputSubmit.title = product_variants[variant].title;
          inputSubmit.value = product_variants[variant].title;
          form.appendChild(inputSubmit);
          sizeWrapper.appendChild(form);
        } else {
          let newDiv = document.createElement("div");
          newDiv.className = "quick_size_button not-available";
          let textNode = document.createTextNode(
            product_variants[variant].title
          );
          newDiv.appendChild(textNode);
          sizeWrapper.appendChild(newDiv);
        }
      }

      $(oldSizeWrapper).remove();
      sizeWrapperParent[0].appendChild(sizeWrapper);
    }
  }
  function buildCarousel(productTile, allProducts) {
    let productId = productTile.dataset.id,
      newProduct = {};
    for (let i in allProducts) {
      if (allProducts[i].id == productId) {
        newProduct = allProducts[i];
        break;
      }
    }
    var itemInfo = $(productTile).find(".ProductItem__Info")[0];
    var carouselParent = $(productTile).find(".product-color-swatch")[0];

    var swatchGroup = "";
    var colors = [];
    for (let t in newProduct.tags) {
      if (newProduct.tags[t].includes("__swatch group")) {
        swatchGroup = newProduct.tags[t].split(":").pop();
        break;
      }
    }
    if (swatchGroup != "") {
      for (let i in allProducts) {
        for (let tag in allProducts[i].tags) {
          if (allProducts[i].tags[tag].includes(swatchGroup)) {
            for (let k in allProducts[i].tags) {
              if (allProducts[i].tags[k].includes("__swatch color")) {
                let color = allProducts[i].tags[k].split(":").pop();
                let swatch = {};
                var url_color = Utils.getFilePath(
                  Utils.slugify(color),
                  Globals.swatchExtension,
                  Settings.getSettingValue("general.swatchImageVersion")
                );
                swatch.id = allProducts[i].id;
                swatch.href = "/products/" + allProducts[i].handle;
                swatch.src = url_color;
                swatch.value = color;
                swatch.title = allProducts[i].title;
                swatch.images = allProducts[i].image;
                swatch.price = allProducts[i].price;
                swatch.compare_at_price = allProducts[i].compare_at_price_max;
                colors.push(swatch);
              }
            }
          }
        }
      }
    }

    if (colors.length > 0) {
      let hidden = colors.length < 7;
      let wrapper = document.createElement("div");
      wrapper.className = "swatch-wrapper";
      let buttons = document.createElement("div");
      buttons.className = "color-buttons";
      let leftArrow = document.createElement("button");
      leftArrow.style = "visibility: hidden;";
      leftArrow.className = "slideshow__arrow slideshow__arrow-previous";
      leftArrow.setAttribute("aria-label", "Previous slide");
      let leftSVG = document.createElement("svg");
      leftSVG.className = "Icon Icon--select-arrow-left";
      leftSVG.setAttribute("role", "presentation");
      leftSVG.setAttribute("viewBox", "0 0 11 18");
      let leftPath = document.createElement("path");
      leftPath.setAttribute("d", "M9.5 1.5L1.5 9l8 7.5");
      leftPath.setAttribute("stroke-width", "2");
      leftPath.setAttribute("stroke", "currentColor");
      leftPath.setAttribute("fill", "none");
      leftPath.setAttribute("fill-rule", "evenodd");
      leftPath.setAttribute("stroke-linecap", "square");
      leftSVG.appendChild(leftPath);
      leftArrow.appendChild(leftSVG);
      leftArrow.style = "visibility: hidden;";
      let rightArrow = document.createElement("button");
      rightArrow.style = "visibility: visible;";
      rightArrow.className = "slideshow__arrow slideshow__arrow-next";
      rightArrow.setAttribute("aria-label", "Next slide");
      let rightSVG = document.createElement("svg");
      rightSVG.className = "Icon Icon--select-arrow-right";
      rightSVG.setAttribute("role", "presentation");
      rightSVG.setAttribute("viewBox", "0 0 11 18");
      let rightPath = document.createElement("path");
      rightPath.setAttribute("d", "M9.5 1.5L1.5 9l8 7.5");
      rightPath.setAttribute("stroke-width", "2");
      rightPath.setAttribute("stroke", "currentColor");
      rightPath.setAttribute("fill", "none");
      rightPath.setAttribute("fill-rule", "evenodd");
      rightPath.setAttribute("stroke-linecap", "square");
      rightSVG.appendChild(rightPath);
      rightArrow.appendChild(rightSVG);
      if (hidden) {
        rightArrow.style = "visibility: hidden;";
      }
      buttons.appendChild(leftArrow);
      buttons.appendChild(rightArrow);
      wrapper.appendChild(buttons);
      let colorCarousel = document.createElement("div");
      colorCarousel.className = "color-carousel swatch-colors carousel";
      for (let i in colors) {
        if (colors[i].title === newProduct.title) {
          let anchor = document.createElement("a");
          anchor.className = "Slideshow__Cell color_wrapper swatch";
          anchor.setAttribute("data-id", colors[i].id);
          anchor.setAttribute("data-url", colors[i].href);
          if (typeof colors[i].images === "object" && colors[i].length > 1) {
            anchor.setAttribute("data-image", colors[i].images[0]);
            anchor.setAttribute("data-image-alt", colors[i].images[1]);
          }
          if (typeof colors[i].images === "object" && colors[i].length === 1) {
            anchor.setAttribute("data-image", colors[i].images[0]);
            anchor.setAttribute("data-image-alt", colors[i].images[0]);
          } else {
            anchor.setAttribute("data-image", colors[i].images);
            anchor.setAttribute("data-image-alt", colors[i].images);
          }
          anchor.setAttribute("data-title", colors[i].title);
          anchor.setAttribute(
            "data-price",
            "$" + colors[i].price.replace(".00", "")
          );
          anchor.setAttribute(
            "data-compare-price",
            "$" + colors[i].compare_at_price.replace(".00", "")
          );
          let colorImg = document.createElement("img");
          colorImg.src = colors[i].src;
          colorImg.setAttribute("title", colors[i].title);
          colorImg.setAttribute("width", "50px");

          colorImg.style = "border: solid 2px #666;";
          anchor.appendChild(colorImg);
          colorCarousel.appendChild(anchor);
        }
      }
      for (let i in colors) {
        if (colors[i].title != newProduct.title) {
          let anchor = document.createElement("a");
          anchor.className = "Slideshow__Cell color_wrapper swatch";
          anchor.setAttribute("data-id", colors[i].id);
          anchor.setAttribute("data-url", colors[i].href);
          if (typeof colors[i].images === "object" && colors[i].length > 1) {
            anchor.setAttribute("data-image", colors[i].images[0]);
            anchor.setAttribute("data-image-alt", colors[i].images[1]);
          }
          if (typeof colors[i].images === "object" && colors[i].length === 1) {
            anchor.setAttribute("data-image", colors[i].images[0]);
            anchor.setAttribute("data-image-alt", colors[i].images[0]);
          } else {
            anchor.setAttribute("data-image", colors[i].images);
            anchor.setAttribute("data-image-alt", colors[i].images);
          }
          anchor.setAttribute("data-title", colors[i].title);
          anchor.setAttribute(
            "data-price",
            "$" + colors[i].price.replace(".00", "")
          );
          anchor.setAttribute(
            "data-compare-price",
            "$" + colors[i].compare_at_price.replace(".00", "")
          );
          let colorImg = document.createElement("img");
          colorImg.src = colors[i].src;
          colorImg.setAttribute("title", colors[i].title);
          colorImg.setAttribute("width", "50px");

          colorImg.style = "border: solid 1px #ccc;";
          anchor.appendChild(colorImg);
          colorCarousel.appendChild(anchor);
        }
      }
      wrapper.appendChild(colorCarousel);
      carouselParent.appendChild(wrapper);
    }
    itemInfo.appendChild(carouselParent);
  }
  function initializeCarousels(productTile) {
    let html = "";
    let allProducts = boostPFSAppConfig.products;

    if (allProducts.length !== 0) {
      //        buildCarousel(productTile, allProducts);
      initializeCarouselArrows(productTile);
      initializeSwatches(productTile);
    } else {
      let titleElem = $(productTile).find(".ProductItem__Title");
      let title = titleElem.text().trim().replaceAll(" ", "-").toLowerCase();
      var swatchGroup = "";

      let queryUrl =
        window.Shopify.routes.root +
        `search/suggest.json`;
      $.getJSON(
        queryUrl,
        {
          q: title,
          resources: {
            type: "product",
            limit: 20,
            options: {
              fields: "tag",
            },
          },
        },
        (response) => {
          buildCarousel(productTile, response.resources.results.products);
          initializeCarouselArrows(productTile);
          initializeSwatches(productTile);
        }
      );
    }
  }

  function switchVariant(productTile, variantData) {
    let carousel = $(productTile).find(".carousel"),
      swatches = Array.from($(carousel).children()),
      title = $(productTile).find(".ProductItem__Title").children("a")[0],
      prices = $(productTile).find(".ProductItem__Price"),
      imageWrapper = $(productTile).find(".ProductItem__ImageWrapper")[0],
      imageFeature = $(productTile).find(".ProductItem__Image:not(.ProductItem__Image--alternate)")[0],
      imageAlt = $(productTile).find(".ProductItem__Image.ProductItem__Image--alternate")[0];

    if (prices.length > 2) {
      prices[1].innerText = variantData.price;
      prices[2].innerText = variantData.comparePrice;
    } else if (prices.length === 2) {
      prices[0].innerText = variantData.price;
      prices[1].innerText = variantData.comparePrice;
    } else {
      prices[0].innerText = variantData.price;
    }

    productTile.dataset.id = variantData.id;

    title.innerText = variantData.title;
    title.href = variantData.url;

    imageWrapper.href = variantData.url;
    imageFeature.srcset = variantData.image;
    if (imageAlt) {
      imageAlt.srcset = variantData.imageAlt;
    }
    swatches.map((el, index) => {
      if (el.dataset.id === variantData.id) {
        $(el).children("img").css("border", "solid 2px #666");
      } else {
        $(el).children("img").css("border", "solid 1px #ccc");
      }
    });

    // remove the quick-add
    initializeQuickAdd(productTile);
  }

  function scrollCarouselLeft(element) {
    scrollCarousel(element, "-=");
  }
  function scrollCarouselRight(element) {
    scrollCarousel(element, "+=");
  }
  function scrollCarousel(element, operator) {
    let arrows = $(element).parent().find(".slideshow__arrow");
    $(element).animate({ scrollLeft: operator + `${$(element).width()}px` });
    checkOverflow(element, arrows[0], arrows[1]);
  }

  function setup() {
    let gridCells = Array.from($(".Grid__Cell"));
    if (gridCells.length) {
      gridCells.map(function (el, index) {
        initializeProductTile(el);
      });
    } else {
      initializeCarouselArrows($(".Product"));
    }
  }
  $(document).ready(function () {
    setup();
    window.onresize = checkOverflow;
  });
}

$(document).ready(productItemSetup);
